const topicTags = [
  { name: '网红翻车', hot: true },
  { name: '艺人塌房', hot: true },
  { name: '直播内幕', hot: false },
  { name: 'MCN爆料', hot: true },
  { name: '合同纠纷', hot: false },
  { name: '品牌解约', hot: true },
  { name: '饭圈动态', hot: false },
  { name: '综艺黑幕', hot: false },
  { name: '代言风波', hot: false },
  { name: '社会事件追踪', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">热搜话题</h2>
          <p className="text-foreground-500 text-sm mt-1">全网吃瓜群众正在热议的关键词</p>
        </div>

        <div className="flex flex-wrap gap-2.5 md:gap-3">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#topics"
              className={`inline-block px-4 py-2 text-sm rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                tag.hot
                  ? 'bg-accent-500 text-white hover:bg-accent-600'
                  : 'bg-background-100 text-foreground-600 border border-background-300 hover:border-foreground-300 hover:text-foreground-800'
              }`}
            >
              {tag.hot && <i className="ri-fire-line mr-1 w-4 h-4 inline-flex items-center justify-center align-text-bottom"></i>}
              {tag.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}